// extracted by mini-css-extract-plugin
module.exports = {"file":"styles__file___1etMo","action":"styles__action___2EB6o","close-icon":"styles__close-icon___2if2C","placeholder":"styles__placeholder___1FvG3","name":"styles__name___7QlV4"};